import useTranslation from '../../hooks/useTranslation'
import FullHeightContainer from '../../UI/FullHeightContainer/FullHeightContainer'
import Container from '../../UI/Container/Container'
import SlideInView from '../../UI/SlideInView/SlideInView'
import FloatingHeadline from '../../UI/FloatingHeadline/FloatingHeadline'
import Headline from '../ui/Headline'
import Text from '../ui/Text'
import image from '../../../assets/image/processes/image.png'

function ProcessesSection() {
  const t = useTranslation()
  const { tagline, headingLines, body } = t.landing.processes
  return (
    <FullHeightContainer center>
      <div>
        <Container>
          <SlideInView>
            {/* <FloatingHeadline text={tagline} /> */}
            <div className="flex flex-col md:flex-row md:items-end gap-10 md:gap-0">
              <div className="flex flex-col gap-6 w-full md:w-6/12">
                <Headline size="xlarge" headline={headingLines.join(' ')} />
                <Text text={body} size="xlarge" />
              </div>
              <img src={image} alt="Analytics" className="w-full md:w-6/12 h-auto" />
            </div>
          </SlideInView>
        </Container>
      </div>
    </FullHeightContainer>
  )
}

export default ProcessesSection
